import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import 'flag-icons/css/flag-icons.min.css';

const LANGUAGES = [
  { code: 'de', countryCode: 'de', label: 'Deutsch' },
  { code: 'en', countryCode: 'gb', label: 'English' },
];

function LanguageDropdown({ compact = false }) {
  const { lang, setLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = LANGUAGES.find(l => l.code === lang) || LANGUAGES[0];

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={() => setOpen(o => !o)}
        title={lang === 'de' ? 'Switch language' : 'Sprache wechseln'}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: compact ? '4px' : '6px',
          padding: compact ? '4px 8px' : '6px 10px',
          borderRadius: '8px',
          border: '1px solid rgba(148,163,184,0.4)',
          background: 'transparent',
          cursor: 'pointer',
          fontSize: compact ? '13px' : '14px',
          fontWeight: 600,
          color: 'inherit',
          lineHeight: 1,
          whiteSpace: 'nowrap',
        }}
      >
        <span className={`fi fi-${current.countryCode}`} style={{ fontSize: compact ? '16px' : '18px', lineHeight: 1, borderRadius: '2px' }}></span>
        <span>{current.code.toUpperCase()}</span>
        <span style={{ fontSize: '10px', opacity: 0.6, marginLeft: '1px' }}>{open ? '▲' : '▼'}</span>
      </button>

      {open && (
        <div style={{
          position: 'absolute',
          ...(compact
            ? { bottom: 'calc(100% + 6px)', left: 0 }
            : { top: 'calc(100% + 6px)', right: 0 }),
          minWidth: '140px',
          background: 'var(--card-bg, #1e293b)',
          border: '1px solid rgba(148,163,184,0.25)',
          borderRadius: '10px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
          zIndex: 9999,
          overflow: 'hidden',
        }}>
          {LANGUAGES.map(l => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                width: '100%',
                padding: '10px 14px',
                border: 'none',
                background: l.code === lang ? 'rgba(232,183,58,0.15)' : 'transparent',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: l.code === lang ? 700 : 500,
                color: l.code === lang ? '#e8b73a' : 'inherit',
                textAlign: 'left',
              }}
            >
              <span className={`fi fi-${l.countryCode}`} style={{ fontSize: '18px', borderRadius: '2px' }}></span>
              <span>{l.label}</span>
              {l.code === lang && <span style={{ marginLeft: 'auto', fontSize: '12px' }}>✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageDropdown;
